module.exports = dns;